var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D4B41739-F60F-4CEE-AFCD-DC5BFCF7F106") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-24, -280)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-info",
    transform: "translate(24, 280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,1 C4.13359392,1 1,4.13359392 1,8 C1,11.8664061 4.13359392,15 8,15 C11.8664061,15 15,11.8664061 15,8 C15,4.13359392 11.8664061,1 8,1 Z",
    id: "Path",
    fill: "#C5CDD3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27604167,10.5520833 L8.765625,10.5520833 L8.765625,7.74479167 C8.765625,7.32369801 8.42428346,6.97916667 8,6.97916667 L6.97916667,6.97916667 C6.55807301,6.97916667 6.21354167,7.32369801 6.21354167,7.74479167 C6.21354167,8.16588581 6.55807301,8.51041667 6.97916667,8.51041667 L7.234375,8.51041667 L7.234375,10.5520833 L6.72395833,10.5520833 C6.30286468,10.5520833 5.95833333,10.8966142 5.95833333,11.3177083 C5.95833333,11.7388025 6.30286468,12.0833333 6.72395833,12.0833333 L9.27604167,12.0833333 C9.69873047,12.0833333 10.0416667,11.7403971 10.0416667,11.3177083 C10.0416667,10.8950195 9.70032513,10.5520833 9.27604167,10.5520833 Z M8,5.95833333 C8.56369183,5.95833333 9.02083333,5.50119086 9.02083333,4.9375 C9.02083333,4.37380914 8.56369183,3.91666667 8,3.91666667 C7.43630817,3.91666667 6.97916667,4.37285117 6.97916667,4.9375 C6.97916667,5.50214883 7.43535166,5.95833333 8,5.95833333 Z",
    id: "Combined-Shape",
    fill: "#7A858E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/iconInfo.c67f68827247ea39b206a976d9469037.svg";
export { ForwardRef as ReactComponent };